// **********************************************************
// gallery slider
// **********************************************************

const gallerySwiperElements = document.querySelectorAll('[data-slider="gallery-slider"]');
const gallerySliderOptions = {
  slidesPerView: 1,
  spaceBetween: 12,
  speed: 600,
  loop: true,
  navigation: {
    nextEl: '.swiper-button-prev',
    prevEl: '.swiper-button-next',
  },
  breakpoints: {
    586: {
      slidesPerView: 2,
      spaceBetween: 12,
    },
    769: {
      slidesPerView: 4,
      spaceBetween: 20,
    },
  },
};

gallerySwiperElements.forEach((el) => {
  const mainSliderParent = el.closest('.sc-gallery-module');
  const arrowRight = mainSliderParent.querySelector('.swiper-button-next');
  const arrowLeft = mainSliderParent.querySelector('.swiper-button-prev');

  gallerySliderOptions.navigation.nextEl = arrowRight;
  gallerySliderOptions.navigation.prevEl = arrowLeft;

  new Swiper(el, gallerySliderOptions);
});
